/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {IssueAuthenticatedMoneybotSessionRequest} from '@cash-web/protos/squareup/cash/janus/api/JanusService.pb'
import {IssueAuthenticatedMoneybotSessionResponse} from '@cash-web/protos/squareup/cash/janus/api/JanusService.pb'


export const issueAuthenticatedMoneybotSession = (request: IssueAuthenticatedMoneybotSessionRequest, options?: CashRequestOptions) => post<IssueAuthenticatedMoneybotSessionRequest, IssueAuthenticatedMoneybotSessionResponse>("/2.0/cash/issue-authenticated-moneybot-session", request, {...options, rejectOnError: true })